<template>
    <div>
        <b-tabs class="emisiones" v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    Cobrar                
                </template>
                <template v-if="tabIndex == 0">
                    <cobrar  @tabindex="changeTab" @ruc="ruc"></cobrar>
                </template>
            </b-tab>
            <!-- pestaña "pagar" temporal hasta habilitar nueva pestaña pagos -->
            <!-- <b-tab title="Pagar">
                <template v-if="tabIndex == 1">
                    <pagar></pagar>                    
                </template>
            </b-tab> -->
            <b-tab title="Estado de cuenta">
                <template v-if="tabIndex == 1">
                    <estado :datos="datos" :rucCobranza="rucCobranza"></estado>              
                </template>
            </b-tab>
            <b-tab title="Reporte de cobro">
                <template v-if="tabIndex == 2">
                    <pagos></pagos> 
                </template>
            </b-tab>
            <b-tab title="Pendiente de cobros">
                <template v-if="tabIndex == 3">
                    <pendientes></pendientes>
                </template>
            </b-tab>
        </b-tabs>
    </div> 
</template>

<script>
import Cobrar from '@/components/gestion/CuentasCobrar'
import Pagar from '@/components/gestion/CuentasPagar'
import Estado from '@/components/gestion/EstadoCuenta'
import Pagos from '@/components/gestion/ReportePagos'
import Pendientes from '@/components/gestion/PendientesPago'
    export default {
      name: 'Cobranzas',
      components: {
          Cobrar,
          Pagar,
          Estado,
          Pagos, 
          Pendientes
      },
      data: () => {
          return {
              tabIndex: 0,
              datos: {
                  tipo: 1,
                  documento: ''
              },
              rucCobranza:'',
          }
        },
        watch:{
            tabIndex(){
               if(this.tabIndex !=1){
                   this.rucCobranza = ''
               }
            }
        },
        methods:{
            changeTab(value){
                this.tabIndex = value
            },
            ruc(value){
                this.rucCobranza = value
            },
        }  
    }
</script>

<style>
h6{
  margin-bottom: 0px !important;
}
</style>